import { render } from "./NumericPreview.vue?vue&type=template&id=5049ef06&scoped=true"
import script from "./NumericPreview.vue?vue&type=script&lang=js"
export * from "./NumericPreview.vue?vue&type=script&lang=js"

import "./NumericPreview.vue?vue&type=style&index=0&id=5049ef06&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5049ef06"]])

export default __exports__